import React from "react";
import { Divider, Tag, Typography } from "antd";
import { ResumeCertification } from "../../Entities/UserProfile";

interface ResumeOtherInfoProps {
  otherDetails: string | null;
  languages: string[];
  achievements: string[];
  certifications: ResumeCertification[];
}

const ResumeOtherInfo: React.FC<ResumeOtherInfoProps> = ({
  otherDetails,
  languages,
  achievements,
  certifications,
}) => {
  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined" style={{ margin: 0 }}>
            other_admission
          </span>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Other Info
          </Typography.Title>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      {otherDetails && (
        <Typography.Paragraph
          style={{ fontSize: "13px", fontStyle: "italic", margin: 0 }}
          type="secondary"
        >
          <strong style={{ fontSize: "14px" }}>•</strong> {otherDetails}
        </Typography.Paragraph>
      )}
      {languages.length > 0 && (
        <div className="other-details-content">
          <div className="resume-preview-card-header-title">
            <span className="material-symbols-outlined" style={{ margin: 0 }}>
              translate
            </span>
            <Typography.Text strong>Languages</Typography.Text>
          </div>
          <div className="resume-preview-skills-list">
            {languages.map((l, i) => (
              <Tag key={i} color="processing">
                <Typography.Text>{l}</Typography.Text>
              </Tag>
            ))}
          </div>
        </div>
      )}
      {achievements.length > 0 && (
        <div className="other-details-content">
          <div className="resume-preview-card-header-title">
            <span className="material-symbols-outlined" style={{ margin: 0 }}>
              award_star
            </span>
            <Typography.Text strong>Achievements</Typography.Text>
          </div>
          <ul className="other-details-list">
            {achievements.map((a, i) => (
              <li key={i}>
                <Typography.Text>{a}</Typography.Text>
              </li>
            ))}
          </ul>
        </div>
      )}
      {certifications.length > 0 && (
        <div className="other-details-content">
          <div className="resume-preview-card-header-title">
            <span className="material-symbols-outlined" style={{ margin: 0 }}>
              license
            </span>
            <Typography.Text strong>Certifications</Typography.Text>
          </div>
          <div className="other-details-certifications">
            {certifications.map((c, i) => (
              <div key={i} className="certification-item">
                <Typography.Text strong>{c.name}</Typography.Text>
                <Typography.Text type="secondary">
                  {c.issuer}{c.year ? ` · ${c.year}` : ""}
                </Typography.Text>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default ResumeOtherInfo;